__turbopack_context__.v({
  "author": "tweet-header-module__T3YMAa__author",
  "authorFollow": "tweet-header-module__T3YMAa__authorFollow",
  "authorLink": "tweet-header-module__T3YMAa__authorLink",
  "authorLinkText": "tweet-header-module__T3YMAa__authorLinkText",
  "authorMeta": "tweet-header-module__T3YMAa__authorMeta",
  "authorVerified": "tweet-header-module__T3YMAa__authorVerified",
  "avatar": "tweet-header-module__T3YMAa__avatar",
  "avatarOverflow": "tweet-header-module__T3YMAa__avatarOverflow",
  "avatarShadow": "tweet-header-module__T3YMAa__avatarShadow",
  "avatarSquare": "tweet-header-module__T3YMAa__avatarSquare",
  "brand": "tweet-header-module__T3YMAa__brand",
  "follow": "tweet-header-module__T3YMAa__follow",
  "header": "tweet-header-module__T3YMAa__header",
  "separator": "tweet-header-module__T3YMAa__separator",
  "twitterIcon": "tweet-header-module__T3YMAa__twitterIcon",
  "username": "tweet-header-module__T3YMAa__username",
});
